const calculateAccuracy = (accuracy_per_ab, accuracy_per_mm) => {
    console.log(accuracy_per_ab, accuracy_per_mm);
    const accuracy_per_ab_float = Number(accuracy_per_ab);
    const accuracy_per_mm_float = Number(accuracy_per_mm);
    const average_accuracy = ((accuracy_per_ab_float + accuracy_per_mm_float) / 2).toFixed(2);
    return average_accuracy;
};
export default calculateAccuracy;